// Centralised company branding
export const COMPANY_NAME = "Wellpack Polyplast India Pvt Ltd";
export const COMPANY_SHORT = "WELLPACK POLYPLAST";
export const COMPANY_TAGLINE = "Stretch Film Manufacturing";
export const COMPANY_INITIALS = "WP";
